module.exports = __webpack_public_path__ + "img/dolla.0c47be11.png";